import { useTranslation } from "react-i18next";
import { useAtom } from "jotai";
import { mainArtistAtom } from "../../atoms/artistAtom";
import { useArtists } from "../../hooks/useArtists";
import { useEffect, useState } from "react";
import { Artist } from "../../models/artist";
import { ArtistSelector } from "../common/artistSelector";
import { SupportedLanguages } from "../../models/cacheKey";

export function Settings() {
  const { t, i18n } = useTranslation();
  const [mainArtistId, setMainArtistId] = useAtom(mainArtistAtom);
  const { artists } = useArtists();
  const [mainArtist, setMainArtist] = useState<Artist>();

  useEffect(() => {
    const main = artists?.find((artist) => artist.id === mainArtistId);
    setMainArtist(main);
  }, [artists, mainArtistId]);

  return (
    <>
      <div className={"w-full flex flex-col items-end"}>
        <label>{t("sidemenu_servicelang")}</label>
        <select
          className={"select bg-primary text-primary-content select-sm mt-2"}
          value={i18n.resolvedLanguage}
          onChange={(e) => i18n.changeLanguage(e.target.value)}
        >
          {SupportedLanguages.map((lang) => (
            <option key={lang} value={lang}>
              {t(`sidemenu_servicelang_${lang}`)}
            </option>
          ))}
        </select>
        <label className={"mt-5 mb-2"}>{t("sidemenu_mainartist")}</label>
        <ArtistSelector
          selected={mainArtist}
          onChange={(selected) => setMainArtistId(selected.id)}
        />
      </div>
    </>
  );
}
